import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Legal.css";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="logo" onClick={() => navigate("/")}>
        TOEICMON
      </div>

      <div className="legal-content">
        <div className="legal-header">
          <h1>개인정보 처리방침</h1>
          <p>최종 업데이트: 2024년 5월 1일</p>
        </div>

        <div className="legal-sections">
          <section className="legal-section">
            <h2>1. 수집하는 정보</h2>
            <p>
              1.1. 개인정보: 계정 생성 시 이름, 이메일 주소, 결제 정보를
              수집합니다.
            </p>
            <p>
              1.2. 사용 데이터: 학습 패턴, 시험 점수, 진행 상황 데이터를
              포함하여 플랫폼 사용 방식에 관한 정보를 수집합니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. 정보 사용 방법</h2>
            <p>2.1. 서비스 제공 및 개선</p>
            <p>2.2. 학습 경험 개인화</p>
            <p>2.3. 계정 및 업데이트에 관한 소통</p>
            <p>2.4. 결제 및 이용권 처리</p>
          </section>

          <section className="legal-section">
            <h2>3. 정보 공유</h2>
            <p>3.1. 개인정보를 제3자에게 판매하지 않습니다.</p>
            <p>
              3.2. 플랫폼 운영 및 결제 처리를 지원하는 서비스 제공업체와 정보를
              공유할 수 있습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. 데이터 보안</h2>
            <p>4.1. 개인정보를 보호하기 위해 적절한 보안 조치를 구현합니다.</p>
            <p>4.2. 민감한 데이터 전송 및 저장에 암호화를 사용합니다.</p>
          </section>

          <section className="legal-section">
            <h2>5. 사용자 권리</h2>
            <p>5.1. 개인정보에 접근할 권리가 있습니다.</p>
            <p>5.2. 개인정보 수정을 요청할 수 있습니다.</p>
            <p>5.3. 계정 및 관련 데이터 삭제를 요청할 수 있습니다.</p>
          </section>

          <section className="legal-section">
            <h2>6. 쿠키 및 추적</h2>
            <p>
              6.1. 사용자 경험 개선 및 플랫폼 사용 분석을 위해 쿠키를
              사용합니다.
            </p>
            <p>6.2. 브라우저 설정을 통해 쿠키 설정을 제어할 수 있습니다.</p>
          </section>

          <section className="legal-section">
            <h2>7. 아동의 개인정보</h2>
            <p>
              당사 서비스는 13세 미만 사용자를 대상으로 하지 않습니다. 13세 미만
              아동의 정보를 고의로 수집하지 않습니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. 개인정보 처리방침 변경</h2>
            <p>
              이 개인정보 처리방침은 수시로 업데이트될 수 있습니다. 중요한 변경
              사항은 이메일이나 플랫폼을 통해 알려드립니다.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. 문의하기</h2>
            <p>
              개인정보 처리방침에 관한 질문이 있으시면 support@toeicmon.com으로
              문의해 주세요.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
